export default __webpack_public_path__ + "static/media/backup-generator-true-icon.ed6fe54d.svg";